import {connect} from 'react-redux';
import TestView from "../ui/TestView";

const mapStateToProps = state => {
    let question = state.questions.find(q => q.id === state.testData.currentQId);
    let unanswered = state.questions.find(q => -1 === Number.parseInt(q.result));
    return {
        currentStageTitle: state.testData.stages[question.stage],
        isAllQuestionsAnswered: unanswered === undefined
    }
};

export default connect(mapStateToProps)(TestView)
